import axios from 'axios';
import { get } from 'lodash';
import config from '../config/config';
import { getTokenFromLocalStorage } from './helpers';
import { setSnackBarAlert } from 'app/reducers/slices/AlertsSlice';
import { dispatch } from 'app/reducers/configureStore';
import { redirectUrl } from 'app/config/Constants';

const axiosInstance = axios.create();
axiosInstance.defaults.baseURL = config.API_URL;
axiosInstance.defaults.withCredentials = !config.REACT_APP_LOCAL_DEV;

// Request Interceptor. All Request pass from here
axiosInstance.interceptors.request.use(
  (axiosConfig) => {
    if (!axiosInstance.defaults.withCredentials) {
      if (config.REACT_APP_LOCAL_DEV === true) {
        const accessToken = getTokenFromLocalStorage();
        axiosConfig.headers['Authorization'] = accessToken;
      }
    }

    if (axiosConfig.rawRequest) {
      // header for file_upload, video/audio will handle here i.e raw requests
    } else {
      axiosConfig.headers['Content-Type'] = 'application/json';
    }

    return axiosConfig;
  },
  (error) => {
    Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    if (get(error, 'response.status', '') === 401) {
      window.location.href = redirectUrl;
    } else if (error.message === 'Network Error' && !error.response) {
      dispatch(
        setSnackBarAlert({
          message: `It seems like you're currently offline. Please check your internet connection.`,
          severity: 'error'
        })
      );
    } else {
      return Promise.reject(error);
    }
  }
);

export default axiosInstance;
